import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NotFound = () => {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "notFound",
    children: [/*#__PURE__*/_jsx(Paragraph, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.notFound.description"
      })
    }), /*#__PURE__*/_jsx(ACRouterLink, {
      to: "/",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.notFound.goBackToAcademy"
      })
    })]
  });
};
export default NotFound;